import React from "react";
import styled, { keyframes, css } from "styled-components";
import MuiAlert from "@material-ui/lab/Alert";

const fadeOut = keyframes`
    0% {
        opacity: 1;
    }
    
    80% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
`;

function Alert({ autoHide, fullWidth, ...props }) {
  return <MuiAlert {...props} />;
}

export default styled(Alert).attrs({
  variant: "outlined",
})`
  display: inline-flex;
  border: 0;
  padding: 0;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  ${(props) =>
    props.autoHide
      ? css`
          animation: ${fadeOut} 5s forwards;
        `
      : ""}
`;
